export const mockServerUrl = "https://516f60fe-6c1a-4eca-8b8b-5ffbf30a2932.mock.pstmn.io"

export const systemStatusUrl = "https://facilitynet.instatus.com/"
